module.exports = __webpack_public_path__ + "static/media/_DSC9671_Small.b63a521d.jpg";